var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Checkbox, FormControlLabel, Grid2 as Grid, Typography, } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { enqueueSnackbar } from 'notistack';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ExpandableSection } from '../../../components/ExpandableSection';
import { StaticField } from '../../../components/Form/StaticField';
import { ExpandableSectionFuncionarios } from '../../../components/Funcionario/ExpandableSectionFuncionarios';
import { ExpandableSectionOperadores } from '../../../components/Operador/ExpandableSectionOperadores';
import { RequestLoadingIndicator } from '../../../components/RequestLoadingIndicator';
import { useWizard } from '../../../components/Wizard/useWizard';
import { WizardButtons } from '../../../components/Wizard/WizardButtons';
import { useDialog } from '../../../hooks/useDialog';
import { enviarProcessoEdicao, getProcessoEdicaoResumo, } from '../../../services/processo-edicao.service';
import { useProcessEdicaoContext } from '../context/ProcessEdicaoContext';
import { ExpandableSectionVeiculos } from '../../../components/Veiculo/ExpandableSectionVeiculos';
export var ConfirmacaoForm = function (_a) {
    var disabled = _a.disabled;
    var prevStep = useWizard().prevStep;
    var alert = useDialog().alert;
    var navigate = useNavigate();
    var _b = useProcessEdicaoContext(), processo = _b.processo, servico = _b.servico, isEditable = _b.isEditable;
    var _c = useState(false), isSubmitting = _c[0], setIsSubmitting = _c[1];
    var _d = useState(false), concordaComInformacoes = _d[0], setConcordaComInformacoes = _d[1];
    var _e = useQuery({
        queryKey: ['processo-resumo', processo === null || processo === void 0 ? void 0 : processo.processoEdicaoId],
        queryFn: function () { return getProcessoEdicaoResumo(processo === null || processo === void 0 ? void 0 : processo.processoEdicaoId); },
        enabled: !!(processo === null || processo === void 0 ? void 0 : processo.processoEdicaoId),
    }), processoResumo = _e.data, isLoading = _e.isLoading;
    var handleFinalizarProcesso = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (disabled) {
                        navigate('/processo-edicao');
                        return [2 /*return*/];
                    }
                    if (!processo) {
                        return [2 /*return*/];
                    }
                    if (!concordaComInformacoes) {
                        enqueueSnackbar('Você precisa confirmar que revisou as informações antes de enviar o processo.', {
                            variant: 'warning',
                        });
                        return [2 /*return*/];
                    }
                    setIsSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, enviarProcessoEdicao(processo === null || processo === void 0 ? void 0 : processo.processoEdicaoId)];
                case 2:
                    _a.sent();
                    setIsSubmitting(false);
                    return [4 /*yield*/, alert({
                            title: "Seu processo ".concat(processo.numeroEdicao, " foi enviado com sucesso!"),
                            content: "Voc\u00EA pode acompanhar o andamento do processo na \u00E1rea de acompanhnamento.",
                            okText: 'Ir para a tela inicial',
                        })];
                case 3:
                    _a.sent();
                    navigate('/');
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    console.error('Erro ao enviar o processo:', error_1);
                    setIsSubmitting(false);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var veiculos = processoResumo === null || processoResumo === void 0 ? void 0 : processoResumo.veiculos;
    return (_jsxs(Box, { children: [_jsx(RequestLoadingIndicator, { loading: isLoading || isSubmitting }), _jsx(Typography, { variant: "h6", align: "center", children: "Confirma\u00E7\u00E3o das Informa\u00E7\u00F5es" }), _jsx(Typography, { variant: "body2", align: "center", children: "Revise todos os dados informados e realize a confirma\u00E7\u00E3o de que as informa\u00E7\u00F5es prestadas s\u00E3o verdadeiras, para prosseguir com a sua Solicita\u00E7\u00E3o de Credenciamento." }), _jsx(ExpandableSection, { title: "Servi\u00E7o", children: _jsxs(Grid, { container: true, children: [_jsx(StaticField, { label: "Servi\u00E7o", value: servico === null || servico === void 0 ? void 0 : servico.nome, columns: 6 }), _jsx(StaticField, { label: "Protocolo Edi\u00E7\u00E3o", value: processo === null || processo === void 0 ? void 0 : processo.numeroEdicao, columns: 6 })] }) }), _jsx(ExpandableSectionFuncionarios, { funcionarios: processoResumo === null || processoResumo === void 0 ? void 0 : processoResumo.funcionarios }), veiculos && _jsx(ExpandableSectionVeiculos, { veiculos: veiculos }), _jsx(ExpandableSectionOperadores, { operadores: processoResumo === null || processoResumo === void 0 ? void 0 : processoResumo.operadores }), !disabled && isEditable && (_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', mt: 4 }, children: _jsx(FormControlLabel, { control: _jsx(Checkbox, { checked: concordaComInformacoes, onChange: function (e) { return setConcordaComInformacoes(e.target.checked); } }), label: "Declaro que revisei todas as informa\u00E7\u00F5es e confirmo que as informa\u00E7\u00F5es prestadas por mim s\u00E3o verdadeiras." }) })), _jsxs(Box, { sx: { mt: 2 }, children: [(disabled || !isEditable) && (_jsx(WizardButtons, { nextClick: function () { return navigate('/processo-edicao'); }, prevClick: function () { return prevStep(); }, nextText: 'Ir para a tela de Consulta' })), !disabled && isEditable && (_jsx(WizardButtons, { nextClick: handleFinalizarProcesso, prevClick: function () { return prevStep(); }, isSubmitting: isSubmitting, buttonNextDisabled: disabled || !concordaComInformacoes, nextText: isSubmitting ? 'Enviando...' : 'Confirmar e Salvar' }))] })] }));
};
